<template>
  <div v-loading="pageLoading">
    <div>
      <el-form style="margin: auto; width: 1000px"
      :model="form"
      ref="form"

      >
        <el-form-item label="賬號" :label-width="formLabelWidth" prop="account">
          <el-input
            v-model="form.account"
            autocomplete="off"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="密碼" :label-width="formLabelWidth">
          <el-input
            v-model="form.pwd"
            autocomplete="off"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="分公司"
                      :label-width="formLabelWidth">
          <el-select v-model="form.regionId"
                     filterable
                     placeholder="請選擇分公司"
                     style="width: 80%;"
                     @change="selectRegion">
            <el-option v-for="item in region"
                       :key="item.id"
                       :label="item.regionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部門/物業"
                      :label-width="formLabelWidth">
          <el-select v-model="form.branchId"
                     filterable
                     :placeholder="form.regionId ? '請選擇部門/物業' : '請先選擇部門/物業'"
                     style="width: 80%;"
                     @change="selectBranch"
                     :disabled="!form.regionId">
            <el-option v-for="item in filiale"
                       :key="item.id"
                       :label="item.branchName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用戶組別"
                      :label-width="formLabelWidth">
          <el-select v-model="form.departmentId"
                     filterable
                     :placeholder="form.branchId ? '請選擇用戶組別' : '請先選擇用戶組別'"
                     style="width: 80%;"
                     @change="selectDep"
                     :disabled="!form.branchId">
            <el-option v-for="item in department"
                       :key="item.id"
                       :label="item.departmentName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="職位"
                      :label-width="formLabelWidth">
          <el-select v-model="form.positionId"
                     filterable
                     :placeholder="form.branchId ? '請選擇職位' : '請先選擇職位'"
                     style="width: 80%;"
                     @change="loadEmployee"
                     :disabled="!form.branchId">
            <el-option v-for="item in position"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名"
                      :label-width="formLabelWidth">
          <el-select v-model="form.name"
                     filterable
                     placeholder="请选择姓名"
                     style="width: 80%;"
                     :disabled="!form.positionId || !form.departmentId">
            <el-option v-for="item in employee"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可以發佈資訊">
          <el-radio-group v-model="form.ispublish">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否接收消息通知" v-show="isPersonnel">
          <el-radio-group v-model="isMssage">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$router.back(-1)">取 消</el-button>
        <el-button type="primary" @click="addUser">確 定</el-button>
      </div>
      <el-button class="back" @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data() {
    return {
      form: {
        account: "",
        pwd: "",
        name: "",
        regionId: "",
        branchId: "",
        departmentId: "",
        positionId: "",
        ispublish: "0",
        type: 2,
      },
      region: [],
      filiale: [],
      department: [],
      position: [],
      employee: [],
      formLabelWidth: "130px",
      isMssage: "0",
      isPersonnel: false,
      employeeLoading: false,
      pageLoading: false
    };
  },
  mounted() {
    $("#pageHead").text("新增APP用戶");
    // 獲取級聯
    this.pageLoading = true
    this.$store.dispatch('commonData/getEchoDistrictBranchDepartmentList').then(() => {
      this.region = this.$store.state.commonData.echoDistrictBranchDepartmentList
      this.pageLoading = false
    })
  },
  methods: {
    addUser() {
      var form = that.form;
      var msg = {
        password: form.pwd,
        account: form.account,
        publishedArticles: form.ispublish,
        comUserId: form.name,
      };
      if (form.pwd.length < 0) {
        that.$message({
          type: "warning",
          message: "密碼不能為空",
        });
        return;
      }
      for (let item in msg) {
        if (msg[item] == "") {
          that.$message({
            type: "warning",
            message: "請將信息填寫完整!",
          });
          return;
        }
      }
      
      // if (!(/^[0-9]*$/.test(form.account))) {
      //   this.$message({
      //     type: 'warning',
      //     message: '職員編號只能使用數字'
      //   })
      //   return
      // }

      if (this.isPersonnel) {
        msg["isMssage"] = this.isMssage;
      }
      this.pageLoading = true
      this.axios({
        url: "/manage/addTerUser",
        params: msg,
        method: "post",
      }).then(res => {
        if (res) {
          that.$message({
            type: "success",
            message: "新增成功!",
          });
          setTimeout(function () {
            that.$router.go(-1);
          }, 1000);
        } else {
          this.pageLoading = false
        }
      }).catch(() => {
        this.pageLoading = false
      })
    },
    selectRegion(val) {
      console.log(val)
      // 已選擇地區（分公司）
      var reg = that.region;
      this.isPersonnel = false;
      for (let i = 0; i < reg.length; i++) {
        if (reg[i].id == val) {
          (that.form.branchId = ""),
            (that.form.departmentId = ""),
            (that.form.positionId = ""),
            (that.department = []),
            (that.position = []),
            (that.filiale = reg[i].branchList);
          break;
        }
      }
    },
    selectBranch(val) {
      // 已選部門物業
      var fil = that.filiale;
      this.isPersonnel = false;
      for (let i = 0; i < fil.length; i++) {
        if (fil[i].id == val) {
          that.form.departmentId = '';
          that.form.positionId = '';
          // that.position = [];
          that.department = fil[i].departmentList;
          that.position = fil[i].positionList;

          break;
        }
      }
    },
    selectDep(val) {
      // 已選用户組别
      var dep = that.department;
      for (let i = 0; i < dep.length; i++) {
        if (dep[i].id == val) {
          if (dep[i].departmentName == "人事部") {
            this.isPersonnel = true;
          } else {
            this.isPersonnel = false;
          }
          // that.form.positionId = '',
          break;
        }
      }
    },
    loadEmployee() {
      //職位
      this.employeeLoading = true
      this.form.name = "";
      var msg = this.utils.filtration(that.form);
      this.axios({
        url: "/common/initialize/getAllComUserList",
        params: msg,
      }).then(res => {
        this.employee = res.result;
        this.employeeLoading = false
      });
    },
  },
  created() {
    that = this;
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}
.el-form-item {
  width: 500px;
  display: inline-block;
}
.back {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
